import { atom } from 'nanostores';

import { api, type AdminUsersResponse } from '../lib/api';
import { isStaleSession, messageOf, onSessionCleared, sessionEpoch } from './auth';

export const $adminUsers = atom<AdminUsersResponse | null>(null);
export const $adminUsersLoading = atom(false);
export const $adminUsersError = atom<string | null>(null);

export function resetAdminUsers(): void {
  $adminUsers.set(null);
  $adminUsersLoading.set(false);
  $adminUsersError.set(null);
}

onSessionCleared(resetAdminUsers);

export async function loadAdminUsers(page = 1, limit = 50): Promise<void> {
  const captured = sessionEpoch();
  $adminUsersLoading.set(true);
  $adminUsersError.set(null);
  try {
    const res = await api.adminUsers(page, limit);
    if (isStaleSession(captured)) return;
    $adminUsers.set(res);
  } catch (err) {
    if (isStaleSession(captured)) return;
    $adminUsersError.set(messageOf(err));
  } finally {
    $adminUsersLoading.set(false);
  }
}
